//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      user: {},
    }
  },

  head: {
    title: 'ITANDI 売買 査定システム',
    titleTemplate: 'ITANDI 売買 査定システム | %s',
  },

  computed: {},
}
